import { House, SearchX } from "lucide-react";
import { useLocation, Link } from "react-router-dom";
import styles from "./NotFound.module.css";

function NotFound() {
    const route = useLocation()

    return (
        <main className={styles.container}>
            <div className={styles.containerIcon}>
                <SearchX size={32} color="hsl(220 10% 46%)"/>
            </div>
            <div className={styles.content}>
                <h1>404</h1>
                <p>Página não encontrada</p>
                <p>A rota <code>{route.pathname}</code> não existe</p>
            </div>
            <Link to="/" className={styles.btn}>
                <House/> Ir para início
            </Link>
        </main>
    )
}

export default NotFound;